import Vue from "vue";

const state = {
  maintenanceModeActive: false,
};

function emit(eventName, payload) {
  if (Vue.prototype.$emitter) {
    Vue.prototype.$emitter.emit(eventName, payload);
  }
}

export function activateMaintenanceMode(payload = {}) {
  if (!state.maintenanceModeActive) {
    state.maintenanceModeActive = true;
    emit("maintenance-mode-activated", payload);
  }
}

export function clearMaintenanceMode() {
  if (state.maintenanceModeActive) {
    state.maintenanceModeActive = false;
    emit("maintenance-mode-cleared", {});
  }
}

export function isMaintenanceModeActive() {
  return state.maintenanceModeActive;
}

export function resetAccessGate() {
  state.maintenanceModeActive = false;
}
